






























































































import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { AuthorizationStore, UpdateinfoStore, Payload } from '@samclick-store-factory';
import { _isEmpty } from '@samclick-lodash';
import { emailRegex, isBoa, getPreferredLanguages } from '@/utils/common-utils';

class FormData {
    loading: boolean = false

    affiliateID: string | number = ''

    oldPassword: string = ''

    password: string = ''

    confirmPassword: string =''

    mailAddress: string = ''

    lastName:string = ''

    firstName: string =''

    address: string =''

    promotion: number = 1

    others: string =''

    message : string = ''

    referrer: string = ''

    preferredLanguage: string = 'en'

    gender: string = 'M'

    address2: string = ''

    address3: string = ''

    city: string = ''

    country: string = ''

    zipCode: string = ''

    skype: string = ''

    phone: string = ''

    companyName: string = ''

    selfBilling: number = 1

    taxId: string = ''

    websites: string = ''
}

class UpdateInformationTabState {
    public formData: FormData = new FormData()

    public currentData: object = {}
}

@Component({
  /**
   * Imported components
   * */
  components: {},
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      promotions: (state: any) => state.commons.commonsStore.promotions,
      preferredLanguages: (state: any) => state.commons.commonsStore.preferredLanguages,
      selfBillingItems: (state: any) => state.commons.commonsStore.selfBilling,
      country: (state: any) => state.country.countryStore.countries,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class UpdateInformationTab extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new UpdateInformationTabState();

    rules = {}

  /**
   * Watchers
   * */
  @Watch('state.formData.promotion')
    promotionWatcher(newVal: number, oldVal: number) {
      if (newVal !== 5) {
        this.state.formData.others = '';
      }
    }

  @Watch('ifLocaleChange', { immediate: true })
  localeChanges() {
    this.rules = {
      password: [
        { required: true, validator: this.validatePass, trigger: 'blur' },
        { min: 8, message: this.$t('update_info.err_pass_min'), trigger: 'blur' },
        { max: 20, message: this.$t('update_info.err_pass_max'), trigger: 'blur' },
      ],
      confirmPassword: [
        { required: true, validator: this.confirmPass, trigger: 'blur' },
      ],
      oldPassword: [
        { required: true, validator: this.validateOldPass, trigger: 'blur' },
      ],
      mailAddress: [
        { required: true, message: this.$t('signup.err_email'), trigger: 'blur' },
        { min: 4, message: this.$t('signup.err_email_min'), trigger: 'blur' },
        {
          type: 'email', pattern: this.commonUtil.emailRegex(), message: this.$t('signup.err_email_invalid'), trigger: ['blur', 'change'],
        },
      ],
      lastName: [
        { required: true, message: this.$t('signup.err_last_name'), trigger: 'blur' },
      ],
      firstName: [
        { required: true, message: this.$t('signup.err_first_name'), trigger: 'blur' },
      ],
      address: [
        { required: true, message: this.$t('signup.err_address'), trigger: 'blur' },
      ],
      promotion: [
        { required: true, message: this.$t('signup.err_promotion_strategy'), trigger: 'blur' },
      ],
      others: [
        { required: true, message: this.$t('signup.err_other_promotion_strategy'), trigger: 'blur' },
      ],
      payment: [
        { required: true, message: this.$t('signup.err_payment_type'), trigger: 'blur' },
      ],
      mail: [
        { required: true, message: this.$t('signup.err_email_reg'), trigger: 'blur' },
        { min: 4, message: this.$t('signup.err_email_reg_min'), trigger: 'blur' },
        {
          type: 'email', pattern: this.commonUtil.emailRegex(), message: this.$t('signup.err_email_reg_invalid'), trigger: ['blur', 'change'],
        },
      ],
      lname: [
        { required: true, message: 'Please input Surname', trigger: 'blur' },
      ],
      fname: [
        { required: true, message: 'Please input Name', trigger: 'blur' },
      ],
      gender: [
        { required: true, message: this.$t('signup.err_gender'), trigger: 'blur' },
      ],


      city: [
        { required: true, message: this.$t('signup.err_town_city'), trigger: 'blur' },
      ],
      country: [
        { required: true, message: this.$t('signup.err_country'), trigger: 'blur' },
      ],
      zipCode: [
        { required: true, message: this.$t('signup.err_zip_code'), trigger: 'blur' },
      ],
      phone: [
        { required: true, message: this.$t('signup.err_phonenumber'), trigger: 'blur' },
        { min: 2, message: this.$t('signup.err_phonenumber_min'), trigger: 'blur' },
        { max: 16, message: this.$t('signup.err_phonenumber_max'), trigger: 'blur' },
        { pattern: /^[0-9]+$/, message: this.$t('signup.err_phonenumber_number_only'), trigger: ['blur', 'change'] },
      ],
      preferredLanguage: [
        { required: true, message: this.$t('signup.err_preferred_lang'), trigger: 'blur' },
      ],
      websites: [
        { required: true, message: this.$t('signup.err_website'), trigger: 'blur' },
      ],
      selfBilling: [
        { required: true, message: this.$t('signup.err_self_billing'), trigger: 'blur' },
      ],
      taxId: [
        { required: true, message: this.$t('signup.err_tax_id'), trigger: 'blur' },
      ],
    };
  }

  @Watch('state.currentData')
  detailWatcher(info: object) {
    if (!_isEmpty(info)) {
      this.state.formData.affiliateID = info.id || ''; // * @
      this.state.formData.mailAddress = info.mail || ''; // * @
      this.state.formData.lastName = info.name || ''; // * @
      this.state.formData.firstName = info.fname || ''; // * @
      this.state.formData.address = info.address1 || ''; // * @
      this.state.formData.promotion = info.promotion_strategy || ''; // * @
      this.state.formData.others = info.promotion_other_strategy || ''; // *
      this.state.formData.preferredLanguage = info.preferred_language || 'en'; // * @
      this.state.formData.gender = info.gender || 'M'; // * @
      this.state.formData.address2 = info.address2 || ''; // @
      this.state.formData.address3 = info.address3 || ''; // @
      this.state.formData.city = info.city || ''; // * @
      this.state.formData.country = info.country || ''; // * @
      this.state.formData.zipCode = info.zip_code || ''; // * @
      this.state.formData.skype = info.skype_id || ''; // @
      this.state.formData.phone = info.tel || ''; // * @
      this.state.formData.companyName = info.company_name || '';// @
      this.state.formData.selfBilling = info.self_billing; // *
      this.state.formData.taxId = info.tax_id || ''; // * @
      this.state.formData.websites = info.website || ''; // * @
    }
  }

  /**
   * Methods
   * */
  updateInformation() {
    const {
      affiliateID,
      mailAddress,
      lastName,
      firstName,
      address,
      address2,
      address3,
      promotion,
      others,
      preferredLanguage,
      gender,
      city,
      country,
      zipCode,
      skype,
      phone,
      companyName,
      selfBilling,
      taxId,
      websites,
      oldPassword,
      password,
    } = this.state.formData;
    this.$refs.ruleForm2.validate((valid) => {
      if (valid) {
        this.showAlert(this.$t('api_error.prompt_saving').toString(), this.$data.SamclickAlert.WARNING, true).then(() => {
          UpdateinfoStore.updateInfo(new Payload({
            id: affiliateID,
            mail: mailAddress,
            name: lastName,
            fname: firstName,
            address1: address,
            address2,
            address3,
            promotion_strategy: promotion,
            promotion_other_strategy: others,
            preferred_language: preferredLanguage,
            gender,
            city,
            country,
            zip_code: zipCode,
            skype_id: skype,
            tel: phone,
            company_name: companyName,
            self_billing: selfBilling,
            tax_id: taxId,
            website: websites,
            current_password: oldPassword,
            new_password: password,
          })).then((response) => {
            this.showSuccessAlert();
            this.state.currentData = response.data;
            AuthorizationStore.getMyDetails();
          }, (error) => {
            if (error.status === 400 && error.data && error.data.detail) {
              this.showAlert(
                this.$t(error.data.detail).toString(),
                this.$data.SamclickAlert.ERROR,
              );
            }
          });
        }).catch(() => {});
      }
    });
  }

  confirmPass(rule: any, value: any, callback: any) {
    if (this.state.formData.password && !value) {
      return callback(new Error(this.$t('update_info.err_password_confirm').toString()));
    }
    if (this.state.formData.password && this.state.formData.confirmPassword && this.state.formData.password.toLowerCase() !== this.state.formData.confirmPassword.toLowerCase()) {
      return callback(new Error(this.$t('update_info.err_pass_not_match').toString()));
    }
    return callback();
  }

  validatePass(rule: any, value: any, callback: any) {
    if (!value && (this.state.formData.confirmPassword || this.state.formData.oldPassword)) {
      return callback(new Error(this.$t('update_info.err_enter_password').toString()));
    }
    return callback();
  }

  validateOldPass(rule: any, value: any, callback: any) {
    if (!value && (this.state.formData.confirmPassword || this.state.formData.password)) {
      return callback(new Error(this.$t('update_info.err_enter_curr_password').toString()));
    }
    return callback();
  }

  getPreferredLanguages() {
    const { preferredLanguages } = this;
    return getPreferredLanguages(preferredLanguages);
  }


  /**
  * Computed
  * */
  get computedVal() {
    return {};
  }

  /**
  * Lifecycle hooks
  * */
  created() {
    this.state.currentData = this.clone(AuthorizationStore.currentLoggedUserInState);
  }

  mounted() {

  }

  beforeUpdate() {}

  beforeCreate() {
    this.commonUtil = {
      emailRegex,
    };
  }
}
